<template>
  <FpFlex
    space-around
    compact
    :justify-content="FlexJustifyContent.spaceBetween"
    :align-items="FlexAlignItems.center"
  >
    <FpFlexItem>
      <FpImage
        :style="{ width: '100px', height: '100%' }"
        :title="$t('common.images.flatfairLogo.title')"
      >
        <img
          :src="flatfairLogo"
          :alt="$t('common.images.flatfairLogo.alt')"
          :style="{ cursor: 'pointer', width: '100%' }"
          @click="goToHome"
        />
      </FpImage>
    </FpFlexItem>
    <FpFlexItem>
      <slot />
    </FpFlexItem>
  </FpFlex>
</template>
<script>
import { FpFlex, FpFlexItem, FpImage } from '@flatfair/vue-fairplay';
import flatfairLogo from '@/images/logos/flatfair_all_blue.png';
import FlexMixin from '@/libs/constants/flexMixin';
export default {
  components: {
    FpFlex,
    FpFlexItem,
    FpImage
  },
  mixins: [FlexMixin],
  created() {
    this.flatfairLogo = flatfairLogo;
  },
  methods: {
    goToHome() {
      window.location = '/';
    }
  }
};
</script>
